module.exports = __webpack_public_path__ + "static/default-small-white-e50323b4ee9141d1075da3117672e87c.png";